import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import constant from "constant";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";

function PolicieAdd() {
  const [isLoading, setIsLoading] = useState(false);

  const [covertypeDD, setCovertypeDD] = useState();
  const [coverid, setCoverid] = useState();
  // const [covertype, setCovertype] = useState();

  const [purchasedurationAllDD, setPurchasedurationAllDD] = useState();
  const [durationid, setDurationid] = useState();

  const [purchaselimitDD, setPurchaselimitDD] = useState();
  const [purchaselimitid, setPurchaselimitid] = useState();
  // const [claimid, setClaimid] = useState();

  const [refundDD, setRefundDD] = useState();
  const [refundItem, setRrefundItem] = useState();
  // const [refundid, setRrefundid] = useState();

  const [price, setPrice] = useState();
  const [deposit, setDeposit] = useState();
  const [email, setEmail] = useState();

  const [pricingrefunddurationDD, setPricingrefunddurationDD] = useState();
  const [pricingrefundduration, setPricingrefundduration] = useState();

  const [pricingrefundvalue, setPricingrefundvalue] = useState();

  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();
  const location = useLocation();
  const action = location.state?.action;
  const itemData = location.state?.data;

  const onNew = async () => {
    let pl = {
      coverid, //Popup_covertype,
      durationid, //Popup_duration,
      claimid: purchaselimitid, //Popup_claims,
      price, //pricing,
      deposit,
      email,
      refundid: refundItem?.refundid, //popup_refund,
      pricingrefundvalue: pricingrefundvalue || deposit, //refund_value,
      pricingrefundduration: pricingrefundduration || refundItem?.label, //popup_refund_duration,
    };

    setIsLoading(true);
    let res;
    if (action === "policieadd-edit") {
      pl.id = itemData?.id;
      res = await api.updatePricing(pl);
    } else {
      res = await api.addPricing(pl);
    }

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/policies", {
        state: {},
      });
    }
  };

  const onChangePricingrefunddurationDD = (data) => {
    setPricingrefunddurationDD(data?.list ? [...data.list] : []);
    setPricingrefundduration(data?.item?.data.label);
  };

  const getPricingrefunddurationDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.pricingrefunddurationDD?.map((a, inx) => ({
      key: `refund-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if (data?.default && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.label === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangePricingrefunddurationDD({
      index,
      list,
      item,
    });
  };

  const onChangeRefundDD = (data) => {
    setRefundDD(data?.list ? [...data.list] : []);
    // setRrefundid(data?.item?.data?.label);
    setRrefundItem(data?.item?.data);
  };

  const getRefundDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.refundDD?.map((a, inx) => ({
      key: `refund-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.refundid === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeRefundDD({
      index,
      list,
      item,
    });
  };

  const onPurchaselimitDD = (data) => {
    console.log("onPurchaselimitDD", data);

    setPurchaselimitDD(data?.list ? [...data.list] : []);
    setPurchaselimitid(data?.item?.data?.purchaselimitid);
  };

  const getPurchaselimit = (data) => {
    let index;
    let list;
    let item;

    setIsLoading(true);
    api.getPurchaselimit().then((res) => {
      setIsLoading(false);
      console.log("getPurchaselimit", res.data);
      if (res?.status === 200) {
        if (res?.data && res?.data[0]?.purchaselimitid) {
          list = res.data.map((a, inx) => ({
            key: `purchaselimit-${inx}`,
            value: `${a?.purchaselimitamount}-${inx}`,
            label: `${a?.purchaselimitamount}`,
            data: a,
          }));
        }

        if ((data?.default || data?.default === 0) && list && list[0]) {
          list = list?.map((a, idx) => {
            if (a?.data?.purchaselimitid === data.default) {
              a.selected = true;
              item = a;
              index = idx;
            }
            return a;
          });
        }

        onPurchaselimitDD({
          index,
          list,
          item,
        });
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onPurchasedurationAllDD = (data) => {
    console.log("onPurchasedurationAllDD", data);

    setPurchasedurationAllDD(data?.list ? [...data.list] : []);
    setDurationid(data?.item?.data?.durationid);
  };

  const getPurchasedurationAll = (data) => {
    let index;
    let list;
    let item;

    setIsLoading(true);
    api.getPurchasedurationAll().then((res) => {
      setIsLoading(false);
      console.log("getPurchasedurationAll", res.data);
      if (res?.status === 200) {
        if (res?.data && res?.data[0]?.durationid) {
          list = res.data.map((a, inx) => ({
            key: `purchaseduration-${inx}`,
            value: `${a?.durationvalue} ${a?.durationtype} -${inx}`,
            label: `${a?.durationvalue} ${a?.durationtype}`,
            data: a,
          }));
        }

        if ((data?.default || data?.default === 0) && list && list[0]) {
          list = list?.map((a, idx) => {
            if (a?.data?.durationid === data.default) {
              a.selected = true;
              item = a;
              index = idx;
            }
            return a;
          });
        }

        onPurchasedurationAllDD({
          index,
          list,
          item,
        });
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onChangeCevertypeDD = (data) => {
    setCovertypeDD(data?.list ? [...data.list] : []);
    // setCovertype(data?.item?.label || "");
    setCoverid(data?.item?.data?.coverid);
  };

  const getCovertypeAll = (data) => {
    let index;
    let list;
    let item;

    setIsLoading(true);
    api.getCovertypeAll().then((res) => {
      setIsLoading(false);
      console.log("getCovertypeAll", res.data);
      if (res?.status === 200) {
        if (res?.data && res?.data[0]?.coverid) {
          list = res.data.map((a, inx) => ({
            key: `covertype-${inx}`,
            value: `${a.covername}-${inx}`,
            label: a.covername,
            data: a,
          }));
        }

        if ((data?.default || data?.default === 0) && list && list[0]) {
          list = list?.map((a, idx) => {
            if (a?.data?.coverid === data.default) {
              a.selected = true;
              item = a;
              index = idx;
            }
            return a;
          });
        }

        onChangeCevertypeDD({
          index,
          list,
          item,
        });
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  useEffect(() => {
    console.log("useEffect", itemData);

    if (action === "policieadd-edit") {
      setPrice(itemData?.price || 0);
      setDeposit(itemData?.deposit || 0);
      setEmail(itemData?.email || "");

      getCovertypeAll({ default: itemData?.coverid });
      getPurchasedurationAll({ default: itemData?.durationid });
      getPurchaselimit({ default: itemData?.purchaselimitid });
      getRefundDD({ default: itemData?.refundid });

      getPricingrefunddurationDD({
        default: itemData?.pricingrefundduration,
      });
      setPricingrefundvalue(itemData?.pricingrefundvalue || "");
    } else {
      getCovertypeAll();
      getPurchasedurationAll();
      getPurchaselimit();
      getRefundDD({ default: 4 });
      getPricingrefunddurationDD();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`${
          itemData?.covername
            ? "Pricing - " + itemData?.covername
            : "New Pricing"
        }`}
        isLoading={isLoading}
      />
      <Layout>
        <Text color={"textv2.brand"}>
          This prices apply to all dealers. To set exceptions go to Pricing and
          Exceptions page.
        </Text>
        <SimpleGrid
          mt={"1rem"}
          columns={ismobile ? 1 : 2}
          gap={"1rem"}
          flexDirection={"column"}
        >
          <InputComp
            type={"dropdown"}
            label={"Cover Type"}
            items={covertypeDD}
            onChange={onChangeCevertypeDD}
          />
          <InputComp
            type={"dropdown"}
            label={"Duration"}
            items={purchasedurationAllDD}
            onChange={onPurchasedurationAllDD}
          />
          <InputComp
            type={"dropdown"}
            label={"Claim Amount"}
            items={purchaselimitDD}
            onChange={onPurchaselimitDD}
          />
          {/* <DropDown label={"Duration"} /> */}
          {/* <DropDown label={"Claim Amount"} /> */}
          <InputComp
            label={"Price"}
            type={"number"}
            value={price}
            onChange={setPrice}
          />
          <InputComp
            label={"Deposit"}
            type={"number"}
            value={deposit}
            onChange={setDeposit}
          />
          <InputComp label={"Email"} value={email} onChange={setEmail} />
          <InputComp
            type={"dropdown"}
            label={"Refund"}
            items={refundDD}
            onChange={onChangeRefundDD}
          />

          {refundItem?.refundid === 6 ? (
            <>
              <Flex />
              <InputComp
                type={"number"}
                label={" "}
                value={pricingrefundvalue}
                onChange={setPricingrefundvalue}
              />
              <Flex />

              <InputComp
                type={"dropdown"}
                label={" "}
                items={pricingrefunddurationDD}
                onChange={onChangePricingrefunddurationDD}
              />
            </>
          ) : null}
        </SimpleGrid>
      </Layout>
      <ButtonComp
        alignSelf={"end"}
        mt={"1rem"}
        label={"Save"}
        onClick={onNew}
        keyname={"save"}
        disabled={isLoading}
      />
    </Flex>
  );
}

export default PolicieAdd;
